import Head from 'react-helmet';
import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';
import type { Breadcrumb } from 'app/types/breadcrumb.type';

import { getItemPage, getListingFaqSchema } from './controller';

type ListingStructuredDataProps = {
  breadcrumbs?: Array<Breadcrumb>;
};

const ListingStructuredData = ({ breadcrumbs = [] }: ListingStructuredDataProps) => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);

  if (!listing) {
    return null;
  }

  const schemaCategories = [];
  const isTrusted = listing.trusted;

  schemaCategories.push(getItemPage(listing, breadcrumbs, isTrusted));

  if (isTrusted) {
    schemaCategories.push(getListingFaqSchema(listing));
  }

  return (
    <Head
      script={[
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'http://schema.org',
            '@graph': schemaCategories,
          }),
        },
      ]}
    />
  );
};

export default ListingStructuredData;
